var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2927 3.86118L1.82271 18.0012C1.64807 18.3036 1.55567 18.6465 1.5547 18.9957C1.55372 19.3449 1.6442 19.6883 1.81713 19.9917C1.99007 20.2951 2.23943 20.5479 2.54041 20.725C2.8414 20.9021 3.18351 20.9973 3.53271 21.0012H20.4727C20.8219 20.9973 21.164 20.9021 21.465 20.725C21.766 20.5479 22.0153 20.2951 22.1883 19.9917C22.3612 19.6883 22.4517 19.3449 22.4507 18.9957C22.4497 18.6465 22.3573 18.3036 22.1827 18.0012L13.7127 3.86118C13.5344 3.56729 13.2834 3.3243 12.9839 3.15567C12.6844 2.98703 12.3464 2.89844 12.0027 2.89844C11.659 2.89844 11.321 2.98703 11.0215 3.15567C10.722 3.3243 10.471 3.56729 10.2927 3.86118Z",
    stroke: "#F25330",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9V13",
    stroke: "#F25330",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17H12.01",
    stroke: "#F25330",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warningIcon.3d9f37961d62d613dadb2c1bec011723.svg";
export { ForwardRef as ReactComponent };